module.exports = __webpack_public_path__ + "img/JourneyBinderconnect1.2a6823c5.png";